import { useCallback } from 'react';
import { BrazeEvents, trackBrazeEvent } from '@blocs.braze';
import { useOpenCallRedirect } from '@blocs.paywall';
import { Profile } from '@minecraft.graphql-operations';

interface SelectedPlan {
  billingCode?: string;
}

export const useTrackOpenCallRegistrationComplete = () => {
  const { redirectToOpenCall } = useOpenCallRedirect();

  const trackOpenCallRegistrationEvent = useCallback(
    (selectedPlan?: SelectedPlan, profileDetails?: Profile) => {
      try {
        if (redirectToOpenCall) {
          trackBrazeEvent(BrazeEvents.OpenCallRegistrationComplete, {
            // eslint-disable-next-line camelcase
            date_created: profileDetails?.created,
            // eslint-disable-next-line camelcase
            plan_code: selectedPlan?.billingCode,
          });
        }
      } catch (error) {
        console.error('Error tracking open call registration braze event', error);
      }
    },
    [redirectToOpenCall]
  );

  return {
    trackOpenCallRegistrationEvent,
  };
};
